module.exports = __webpack_public_path__ + "img/lf6.10349f75.png";